export const getFileSize = (size?: number) => {
	if (!size) return "";
	if (size < 1024) {
		return `(${size} B)`;
	}
	if (size < 1024 * 1024) {
		return `(${(size / 1024).toFixed(2)} KB)`;
	}
	return `(${(size / 1024 / 1024).toFixed(2)} MB)`;
};

export function getFirstElementFromHTML(html, defaultText: string = " ") {
	let tmp = document.createElement("DIV");
	tmp.innerHTML = html;
	const heading = tmp.firstChild;
	return heading?.textContent || defaultText;
}

export function getContentFromHTML(html) {
	let tmp = document.createElement("DIV");
	tmp.innerHTML = html;
	const heading = tmp.firstChild;
	return (tmp.textContent || tmp.innerText || "").replace(heading?.textContent || "", "");
}

export function snakeCase(str: string) {
	return str.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
}

export function paramsCase(str: string) {
	return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}

export function getTranslationPrefix(filePath: string) {
	// get prefix from file path
	// 1. first path after pages if it's inside src/pages
	// 2. first path after components if it's inside src/components
	// 3. otherwise use domain came right after src

	let domain = "global";
	if (filePath.includes("src/pages")) {
		domain = filePath.split("src/pages")[1].split("/")[1];
	} else if (filePath.includes("src/components")) {
		domain = filePath.split("src/components")[1].split("/")[1];
	} else {
		domain = filePath.split("src")[1].split("/")[1];
	}

	// get filename transform it to snake case without extension
	const context = paramsCase(filePath.split("/").pop()?.split(".")[0] ?? "");

	return `${domain.toUpperCase()}.${context}`;
}

export function stripHtmlTags(html: string) {
	const div = document.createElement("div");
	div.innerHTML = html;
	return div.textContent || div.innerText || "";
}
